<template>
    <view class="headers" :style="{backgroundColor: style.background, 
    fontSize: style.fontSize,
    color: style.color}" >
        <div class="item" :style="{color: item.link == pathName ? style.activeColor : style.color}" v-for="(item,index) in style.textList" :key="index" @click="linkTo(item.link)">
            {{ item.text }}
        </div>
    </view>
</template>

<script setup>
    import { ref, computed } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    const router = useRouter();
    const route = useRoute();
    const style = ref(window.globalConfig.headerStyle);
    const linkTo = (link) => {
        if(!link) return;
        router.push({
            path: link
        });
    }
    const pathName = computed(()=>{
        return route.fullPath
    })
</script>

<style lang="scss" scoped>
    .headers {
        max-width: 750px;
        height: 96px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        z-index: 1000;
    }
</style>